import { blindBoxThemes } from "@/mocks/blindBoxThemes";
import SectionHeading from "./SectionHeading";

export default function Themes() {
  return (
    <section
      id="themes"
      className="w-full border-y border-background-200 bg-background-100"
    >
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="盲盒主题"
          title="六种主题盒，各自装些什么"
          desc="主题决定了整盒零食的风味走向。下面按口味倾向分成六类，标注了大致单品数量、参考价位与代表零食，方便按自己的偏好挑选。"
        />

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {blindBoxThemes.map((theme) => (
            <article
              key={theme.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${theme.icon} text-xl`} />
                </span>
                <span className="font-heading text-lg text-foreground-950">
                  {theme.price}
                </span>
              </div>

              <h3 className="mt-4 font-heading text-lg text-foreground-950">
                {theme.name}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {theme.desc}
              </p>

              <div className="mt-4 flex flex-wrap gap-2">
                {theme.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              <div className="mt-4 flex items-center gap-2 border-t border-background-200 pt-4 text-xs text-foreground-600">
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-stack-line text-accent-600" />
                </span>
                常规约 {theme.itemCount} 款单品，含随机分配
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}